import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Router} from '@angular/router';
import {Subscription as RxJsSubscription} from 'rxjs';
import {ErrorService} from '@app/services';
import {Video} from '../../video';
import {VideoService} from '../../video.service';
@Component({
  selector: 'hpf-video-edit',
  templateUrl: './video-edit.component.html'
})
export class VideoEditComponent implements OnInit, OnDestroy {
  /** The video */
  video = new Video();
  /** The video */
  private id: string;
  /** The id subscription */
  private idSubscription: RxJsSubscription;
  /** Constructor */
  constructor(private route: ActivatedRoute,
              private router: Router,
              private errorService: ErrorService,
              private videoService: VideoService) {}
  /** Init */
  ngOnInit() {
    // Get the video after reading the id
    this.idSubscription = this.route.params.subscribe(params => {
        this.id = params['id'];
        this.refresh();
    });
  }
  /** Destroy */
  ngOnDestroy() {
    this.idSubscription.unsubscribe();
  }
  /** Fetch video from API */
  private refresh() {
    this.videoService.get(this.id, { _populate: ['*'] })
      .then((video: Video) => {
        this.video.fromObject(video.toObject());
      })
      .catch((error) => this.errorService.handle(error));
  }
  /** Called when the video is updated */
  onUpdate(): void {
    this.refresh();
  }
  /** Called when the video is deleted */
  onDelete(): void {
    this.router.navigateByUrl('/video')
      .catch((error) => this.errorService.handle(error));
  }
}
